const CONNECTION_TYPES = {
    BLE: 0,
    USB: 1,
};

let connectionType = CONNECTION_TYPES.BLE;

const setIsUsb = () => (connectionType = CONNECTION_TYPES.USB);
const setIsBle = () => (connectionType = CONNECTION_TYPES.BLE);
const resetConnectionType = () => (connectionType = CONNECTION_TYPES.BLE);

const getConnectionType = (type) => {
    const isValidConnectionType = connectionType === CONNECTION_TYPES.BLE || connectionType === CONNECTION_TYPES.USB;

    return isValidConnectionType ? connectionType === type : type === CONNECTION_TYPES.BLE; //if conType is not valid - default is BLE
};

const getConnectionTypeName = () => (isBle() ? 'BLE' : 'USBHID');

const isUsb = () => getConnectionType(CONNECTION_TYPES.USB);
const isBle = () => getConnectionType(CONNECTION_TYPES.BLE);

export default {
    getConnectionTypeName,
    getConnectionType,
    resetConnectionType,
    setIsBle,
    setIsUsb,
    isUsb,
    isBle,
};
